<template>
  <div class="drug-register-view view">
    <div class="actions-panel panel" style="width: fit-content; display: flex; flex-direction: column; margin-right: 20px;" v-if="$store.state.user.role.permissions.includes('can_view_transfers') && $store.state.user.ecdr_active && ($store.state.company.type == 'hospital' || $store.state.user.type == 'clinician')">
      <h3 class="panel-header">Actions</h3>
      <button @click="displayCheckoutModal = true" class="actions-menu-item" v-if="$store.state.company.type == 'hospital'">Theatre Checkout</button>
      <button @click="openCheckin(null)" class="actions-menu-item" style="margin-bottom: 20px;" v-if="$store.state.company.type == 'hospital'">Theatre Check In</button>
      
      <button @click="displayClinicianHoldCheckoutModal = true" class="actions-menu-item" v-if="$store.state.user.type == 'clinician'">Clinician Bag Check Out</button>
      <button @click="openBagCheckinModal" class="actions-menu-item" v-if="$store.state.user.type == 'clinician'">Clinician Bag Check In</button>
    </div>
    <div class="panel" v-if="$store.state.user.role.permissions.includes('can_view_transfers') && $store.state.user.ecdr_active && ($store.state.company.type == 'hospital' || $store.state.user.type == 'clinician')">
      <h3 class="panel-header" style="margin: 0; display: flex; align-items: center;">
        <router-link to="/stock" style="margin-right: 15px; color: black; text-decoration: none;">
          <i class="pi pi-arrow-left"></i>
        </router-link>
        {{ isHospital ? 'Theatre Checkouts' : 'Open Clinician Bags' }}
      </h3>

      <!-- Only a hospital has both workflows to choose between. Everyone else on this screen is a
           clinician with bags and nothing else, so there is nothing to filter. -->
      <div v-if="isHospital" style="display: flex; align-items: center; margin-top: 15px;">
        <div class="select-filters-container">
          <p @click="setTypeFilter('all')"
            v-bind:class="[typeFilter === 'all' ? 'active-select-filter' : '']" class="select-filter-item">All</p>
          <p @click="setTypeFilter('theatre')"
            v-bind:class="[typeFilter === 'theatre' ? 'active-select-filter' : '']" class="select-filter-item">Theatre Checkouts</p>
          <p @click="setTypeFilter('clinician_hold')"
            v-bind:class="[typeFilter === 'clinician_hold' ? 'active-select-filter' : '']" class="select-filter-item">Clinician Bags</p>
        </div>
      </div>

      <div class="drug-register-table table-container" style="margin-top: 20px;">
        <div v-if="loading">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 2em;"></i>
        </div>
        
        <table v-else class="data-table" cellspacing="0">
          <tr class="table-headers">
            <th style="width: 3em;"></th>
            <th style="width: 15em; text-align: left;">Date</th>
            <th style="text-align: left;">Type</th>
            <th style="text-align: left;">Status</th>
            <th style="text-align: left;">Mission Number</th>
            <th style="text-align: left;">Clinician</th>
            <th style="text-align: left;">Medications</th>
            <th style="text-align: left;">Notes</th>
            <th style="width: 8em;"></th>
          </tr>
          <tbody class="table-data" v-for="(item, index) in checkouts" :key="index">
            <tr style="cursor: pointer; height: 50px;" class="drugtablerow" :class="item.expanded ? 'selected-row' : ''" @click="toggleExpand(index)">
              <td style="width: 3em; text-align: center; border-bottom: 1px solid #ccc;">
                <i v-if="item.expanded" class="pi pi-angle-down"></i>
                <i v-else class="pi pi-angle-right"></i>
              </td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc;">{{ new Date(item.created_at).toLocaleString() }}</td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc;">{{ item.type === 'clinician_hold' ? 'Clinician Bag Checkout' : 'Theatre Checkout' }}</td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc;">
                <span :class="item.status === 'open' ? 'green-tag' : 's8-tag'" style="padding: 3px 8px; border-radius: 4px; font-weight: bold;">
                  {{ item.status.toUpperCase() }}
                </span>
              </td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc;">
                {{ item.mission_number ? item.mission_number : 'N/A' }}
              </td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc;">{{ item.clinician && item.clinician.personal_information ? item.clinician.personal_information.firstname + ' ' + item.clinician.personal_information.lastname : 'N/A' }}</td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc;">
                {{ item.drugs.length }} Medication(s)
              </td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc; max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.notes || 'None' }}</td>
              <td style="padding: 10px; border-bottom: 1px solid #ccc; text-align: right;">
                <button v-if="item.status === 'open'" class="submit-button blue-button" style="margin: 0; padding: 5px 15px; font-size: 0.9em;" @click.stop="openCheckin(item)">Check In</button>
              </td>
            </tr>
            <tr v-if="item.expanded" class="expanded-content" style="display: table-row;">
              <td colspan="9" style="padding: 0; border: none;">
               <div class="expanded-transfer-container" style="grid-template-columns: 1fr 3fr">
                    <div class="transfer-notes-container">
                      <div>
                        <h4 class="field-title">Mission Number</h4>
                        <div class="field-notes" style="width: 95%; height: fit-content;">
                            <p>{{ item.external_number ? item.external_number : 'N/A' }}</p>
                        </div>
                      </div>
                      <div>
                        <h4 class="field-title">Tag</h4>
                        <div class="field-notes" style="width: 95%; height: fit-content;">
                            <p>{{ item.tag ? item.tag : 'N/A' }}</p>
                        </div>
                      </div>
                      <div>
                        <h4 class="field-title">Clinician</h4>
                        <div class="field-notes" style="width: 95%; height: fit-content;">
                            <p>{{ item.clinician && item.clinician.personal_information ? item.clinician.personal_information.firstname + ' ' + item.clinician.personal_information.lastname : 'N/A' }}</p>
                        </div>
                      </div>
                      <div>
                        <h4 class="field-title">Notes</h4>
                        <div class="field-notes" style="width: 95%; height: 210px;">
                            <p>{{ item.notes || 'None' }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="transfer-drugs-container">
                        <h4 class="field-title">Drugs</h4>
                        <div class="drug-field-tables" style="width: 100%; border-radius: 4px; height: 300px;">
                         <table style="padding: 0px 5px; border-bottom: 1px solid #E7E9E8">
                             <tr>
                                 <th style="text-align: left;">Name</th>
                                 <th v-if="showBatches" style="width: 120px; text-align: left;">Batch No.</th>
                                 <th style="width: 100px; text-align: left;">Count</th>
                                 <th style="width: 100px; text-align: left;">Remaining</th>
                             </tr>
                         </table>
                         <div style="height: 250px; overflow-y: scroll; background-color: white;">
                             <table style="padding-top: 0;">
                                 <tr v-for="drug in item.drugs" :key="drug.uuid" style="height: 25px">
                                     <td>{{ drug.stock_item && drug.stock_item.alias ? drug.stock_item.alias.name : 'Unknown' }}</td>
                                     <td v-if="showBatches" style="width: 120px;">{{ drug.batch_number || '-' }}</td>
                                     <td style="width: 100px;">{{ drug.quantity }}</td>
                                     <td style="width: 100px;">{{ remaining(drug) }}</td>
                                 </tr>
                             </table>
                         </div>
                        </div>
                    </div>
               </div>
               <div class="transfer-actions-container">
                    <button @click="item.expanded = false" style="background-color: white; padding: 0;"><i class="pi pi-times"></i></button>
               </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!loading && checkouts.length === 0" style="padding: 20px; text-align: center; color: gray;">
          No {{ emptyLabel }} found.
        </div>
      </div>
    </div>
    <div v-else class="drug-register-table table-container" style="padding-top: 5em; height: 78vh;">
        <h3 style="border: 2px solid black; border-bottom: 2px solid black; width: fit-content; height: fit-content; margin: 0 auto; padding: 5px; border-radius: 4px">You do not have permission to access this feature. Please talk to your admin if you require access.</h3>
    </div>
    
    <TheatreCheckoutModal v-if="displayCheckoutModal" @close="close" />
    <TheatreCheckinModal v-if="displayCheckinModal" :preselectedCheckoutId="selectedCheckoutId" @close="close" />
    <ClinicianHoldCheckoutModal v-if="displayClinicianHoldCheckoutModal" @close="close" />
    <ClinicianHoldCheckinModal v-if="displayClinicianHoldCheckinModal" :preselectedCheckoutId="selectedCheckoutId" @close="close" />
    <ConfirmationModal v-if="displayConfirmModal" :actionDescription="'Are you sure you want to check drugs into a bag?'" @close="displayConfirmModal = false" @accepted="confirmBagCheckin" />
    <ConfirmationModal v-if="displayAdministrationPrompt" :actionDescription="'The bag is checked in. Record the patient administrations for this mission now?'" acceptText="Record Administrations" rejectText="Not Now" @close="displayAdministrationPrompt = false" @accepted="startAdministrations" />
    <AmbulanceAdministrationModal v-if="displayAdministrationModal" @close="close"
      :checkinUuid="administrationContext ? administrationContext.checkinUuid : null"
      :presetMissionNumber="administrationContext ? administrationContext.missionNumber : null" />
  </div>
</template>


<script>
import axios from 'axios';
import TheatreCheckoutModal from '@/components/modals/TheatreCheckoutModal.vue';
import TheatreCheckinModal from '@/components/modals/TheatreCheckinModal.vue';
import ClinicianHoldCheckoutModal from '@/components/modals/ClinicianHoldCheckoutModal.vue';
import ClinicianHoldCheckinModal from '@/components/modals/ClinicianHoldCheckinModal.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import AmbulanceAdministrationModal from '@/components/modals/AmbulanceAdministrationModal.vue';

export default {
  components: {
    TheatreCheckoutModal,
    TheatreCheckinModal,
    ClinicianHoldCheckoutModal,
    ClinicianHoldCheckinModal,
    ConfirmationModal,
    AmbulanceAdministrationModal
  },
  data() {
    return {
      // Column toggle. Batches follow the batch module. There is no client toggle: a theatre checkout
      // records a clinician rather than a resident.
      showBatches: this.$store.getters.isBatchTrackingEnabled,
      loading: false,
      checkouts: [],
      displayCheckoutModal: false,
      displayCheckinModal: false,
      displayClinicianHoldCheckoutModal: false,
      displayClinicianHoldCheckinModal: false,
      displayConfirmModal: false,
      // Offered once a bag is back: the administrations given on the mission are recorded after the
      // check in, against the check in row.
      displayAdministrationPrompt: false,
      displayAdministrationModal: false,
      administrationContext: null,
      // Which workflow the list is showing. A hospital runs both and can switch; anywhere else the
      // only reason to be on this screen is clinician bags, and the filter is not offered.
      typeFilter: this.$store.state.company.type == 'hospital' ? 'all' : 'clinician_hold',
      // Set when the check in is started from a row, so the modal opens on that checkout
      // instead of making the user find it again in the dropdown.
      selectedCheckoutId: null
    }
  },
  computed: {
    isHospital() {
      return this.$store.state.company.type == 'hospital';
    },
    emptyLabel() {
      if (!this.isHospital || this.typeFilter === 'clinician_hold') return 'clinician bags';
      if (this.typeFilter === 'theatre') return 'theatre checkouts';
      return 'theatre checkouts or clinician bags';
    }
  },
  mounted() {
    this.fetchCheckouts();
  },
  methods: {
    setTypeFilter(type) {
      if (this.typeFilter === type) return;
      this.typeFilter = type;
      this.fetchCheckouts();
    },
    // Count is the amount that went out and never changes. Kraken works out what is still out,
    // because the two register models account for it differently.
    remaining(drug) {
      return Number(drug.outstanding || 0);
    },
    openCheckin(item) {
      this.selectedCheckoutId = item ? item.uuid : null;
      // The row's own workflow decides which check in opens, because a hospital's list holds both.
      // Called with no row it is the Theatre Check In action, which only a hospital has.
      const isBag = item ? item.type === 'clinician_hold' : !this.isHospital;
      if (isBag) {
        this.startBagCheckin();
        return;
      }
      this.displayCheckinModal = true;
    },
    openBagCheckinModal() {
      this.selectedCheckoutId = null;
      this.startBagCheckin();
    },
    startBagCheckin() {
      if (this.$store.state.currentLocation && this.$store.state.currentLocation.type === 'bag') {
        this.displayConfirmModal = true;
        return;
      }
      this.displayClinicianHoldCheckinModal = true;
    },
    confirmBagCheckin() {
      this.displayConfirmModal = false;
      this.displayClinicianHoldCheckinModal = true;
    },
    toggleExpand(index) {
      this.checkouts[index].expanded = !this.checkouts[index].expanded;
    },
    close(value, status, meta) {
      if (value) {
        // Read before the flags are cleared - only a bag check in leads to the prompt below.
        const wasBagCheckin = this.displayClinicianHoldCheckinModal;

        this.displayCheckoutModal = false;
        this.displayCheckinModal = false;
        this.displayClinicianHoldCheckoutModal = false;
        this.displayClinicianHoldCheckinModal = false;
        this.displayAdministrationModal = false;
        this.selectedCheckoutId = null;

        if (wasBagCheckin && status === 'success') {
          this.administrationContext = meta || null;
          this.displayAdministrationPrompt = true;
        }

        if (status === 'success') {
          this.fetchCheckouts();
        }
      }
    },
    startAdministrations() {
      this.displayAdministrationPrompt = false;
      this.displayAdministrationModal = true;
    },
    fetchCheckouts() {
      this.loading = true;
      // Fetch all checkouts (both open and completed)
      axios.post('/theatre-checkout-search', { type: this.typeFilter }, this.$store.state.header).then(res => {
        let items = res.data.data;
        items.forEach(item => {
          item.expanded = false;
        });
        this.checkouts = items;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.error("Failed to fetch checkouts", err);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
</style>
